import React from "react";
import SEO from "./SEO"; // Import the Global SEO
import config from "../config/config";

const ProductSEO = ({
  title,
  description,
  keywords,
  url,
  image,
  jsonLd,
  price,
  currency = "USD",
  availability
}) => {
  const defaultImage = `${config.metadata.siteUrl}/logo512.png`;

  // Extend JSON-LD with Product-specific data
  const productJsonLd = {
    ...jsonLd,
    "@context": "https://schema.org",
    "@type": "Product",
    "offers": {
      "@type": "Offer",
      "priceCurrency": currency,
      "price": price,
      "availability": availability
    }
  };

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      url={url}
      image={image || defaultImage}
      jsonLd={productJsonLd}
    />
  );
};

export default ProductSEO;
